import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap, map } from 'rxjs/operators';
// import * as moment from 'moment';
// import * as moment_tz from 'node_modules/moment-timezone';

import axios from "axios";


@Injectable({ providedIn: 'root' })
export class PhameeService {
    private defaultUrl: any;
    private defaultUrlControl: any;
    constructor(private http: HttpClient) {

        this.defaultUrl = axios.create({
            baseURL: environment.API
        });

        this.defaultUrlControl = axios.create({
            baseURL: environment.API_CONTROL
        });
    }


    public testAPI(): Observable<any> {

        return this.http.get<any>(`${environment.API}${environment.URL_GET_DETAIL_PLOT_BY_ID}/12313213`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }


    public getPlotDashboard(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_PLOT_DASHBOARD}?farmId=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getDropdownDashboard(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_DROPDOWN_CHILDORG_FARM}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getAllbreedType(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_ALL_BREED_TYPE}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getPlantTypeByBreedTypeId(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_PLANT_TYPE_BY_BREED_TYPE_ID}?BreedTypeId=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public createCrop(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CREATE_CROP}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public closeCrop(plotId, clopId): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_CLOSE_CROP}?plotId=${plotId}&cropId=${clopId}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getPlotbyPlotId(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_PLOT_BY_PLOT_ID}?plotId=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getCropPoleByCropId(id, dateString): Observable<any> {
        let data = {
            cropId: id,
            collectDate: dateString
        }
        return this.http.post<any>(`${environment.API}${environment.URL_GET_CROP_POLE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getDemonstrate(cropId, limit, p): Observable<any> {
        var data_get_demo = {
            crop_id: cropId,
            limit: limit,
            page_no: p,
        }
        return this.http.post<any>(`${environment.API}${environment.URL_GET_EXPERIMENT}`, data_get_demo)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getAvailablePole(startdateReceive, enddateReceive, cropId): Observable<any> {
        var data_get_pole = {
            start_date: startdateReceive,
            end_date: enddateReceive,
            crop_id: cropId
        }
        return this.http.post<any>(`${environment.API}${environment.URL_GET_AVAILABLE_POLE}`, data_get_pole)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getFormGrowData(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_FORM_GROWTH_DATA}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getFormGrowInflorescenceData(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_FORM_GROWTH_INFLORESCENCE_DATA}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public addExperiment(FormAdddata): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_ADD_EXPERIMENT}`, FormAdddata)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getExperimentData(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_EXPERIMENT_DATA}?id=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public editExperiment(FormEditdata): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_EDIT_EXPERIMENT}`, FormEditdata)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getInflorescence(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_INFLORESCENCE}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public manageCropGrowthData(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_MANAGE_CROP_GROWTH_DATA}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getbyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_GROWTH_DATA_BY_ID}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getbyCropId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_GROWTH_FOR_DATATABLE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public exportGrowthData(cropId): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_EXPORT_GROWTH_DATA}?crop_id=${cropId}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public deletebyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_DELETE_GROWTH}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getYieldDataTable(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_YIELD_FOR_DATATABLE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public addYieldRound(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_ADD_YIELD_ROUND}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public editYieldRound(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_EDIT_YIELD_ROUND}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getRoundDatabyId(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_ROUND_DATA}?id=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getYieldCropPoleByCropId(id, crop_yield_round_id): Observable<any> {
        let data = {
            crop_id: id,
            crop_yield_round_id: crop_yield_round_id,
            // collectDate: new Date()
        }
        return this.http.post<any>(`${environment.API}${environment.URL_GET_CROP_POLE_YIELD}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getOrgParam(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_ORG_PARAM}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getFormYieldData(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_FORM_YIELD_DATA}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public manageCropYieldData(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_MANAGE_CROP_YIELD_DATA}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getYieldDataforDataTable(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_YIELD_DATA_FOR_DATATABLE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getYieldbyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_YIELD_DATA_BY_ID}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public deleteYieldbyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_DELETE_YIELD}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public exportYieldRound(cropId): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_EXPORT_YIELD_ROUND}?crop_id=${cropId}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public exportYieldData(cropId,cropYieldRoundId): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_EXPORT_YIELD_DATA}?crop_id=${cropId}&crop_yield_round_id=${cropYieldRoundId}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getPlotMenu(childOrgId): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_PLOT_MENU}?child_org_id=${childOrgId}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getMainYieldTemplates(data): Observable<any> {
        let params:any = {};
        for(let key in data) {
          if (data[key]) {
            params[key] = data[key]
          }
        }
        return this.http.get<any>(`${environment.API}${environment.URL_MAIN_YIELD_TEMPLATES}`,{params: params})
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getYieldTemplates(data): Observable<any> {
        let params:any = {};
        for(let key in data) {
          if (data[key]) {
            params[key] = data[key]
          }
        }
        return this.http.get<any>(`${environment.API}${environment.URL_YIELD_TEMPLATES}`,{params: params})
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getCropPloes(data): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_CROPPOLES}?crop_id=${data.crop_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getYieldData(data): Observable<any> {
        let params:any = {};
        for(let key in data) {
          if (data[key]) {
            params[key] = data[key]
          }
        }
        return this.http.get<any>(`${environment.API}${environment.URL_YIELD_DATA}`,{params:params})
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getYieldDataById(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_YIELD_DATA}/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public createYieldData(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_YIELD_DATA}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public updateYieldData(id,data): Observable<any> {
        return this.http.put<any>(`${environment.API}${environment.URL_YIELD_DATA}/${id}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }


    public deleteYieldData(id): Observable<any> {
        return this.http.delete<any>(`${environment.API}${environment.URL_YIELD_DATA}/${id}`,)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
}